<div class="wrap">
  <div class="tab">
    <div class="connect" (click)="setTabs('login')" [ngClass]="{active_left: show}">
      <p>Se connecter</p>
    </div>
    <div class="register" (click)="setTabs('register')" [ngClass]="{active_right: !show}">
      <p>S'inscrire</p>
    </div>
  </div>

  <div class="content">
    <div class="loading_login" *ngIf="loading" [@register]>
      <h3>Chargement...</h3>
      <mat-spinner></mat-spinner>
    </div>
    <app-login *ngIf="show" [@login]></app-login>
    <app-register *ngIf="!show" [@register]></app-register>
  </div>
</div>